import React from 'react'

class SubmitPlanToUnum extends React.Component {
  renderClaims() {
    if(this.props.hasFiledClaim) {
      return (
        <div>
          <p><b>PLEASE NOTE: </b>This plan has been submitted to Unum, any changes made to your plan will not be reflected in your leave.
            To update future dates, please chat with us.
          </p>
          <a type="button" href= "/app/claims" className="btn btn-lg btn-secondary">View this claim status</a>
        </div>
      )
    } else {
      return (
        <div>
          <h3>Are you ready to file with Unum?</h3>
          <p>If you have finalized your plan, we will guide you through a few short questions to submit it to Unum.</p>
          <a type="button" href= "/claims" className="btn btn-lg btn-secondary">Submit my plan to Unum</a>
        </div>
      )
    }
  }

  render() {
    return (
      <div className="unum-plan">
        { this.props.hasCompanyClaim? this.renderClaims() : '' }
      </div>
    )
  }
}

export default SubmitPlanToUnum